var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg3Dots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 23a2 2 0 110 4 2 2 0 010-4zM18 16a2 2 0 110 4 2 2 0 010-4zM20 11a2 2 0 10-4 0 2 2 0 004 0z",
    fill: "#BFC1C7"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xOCAyM0MxOS4xMDQ2IDIzIDIwIDIzLjg5NTQgMjAgMjVDMjAgMjYuMTA0NiAxOS4xMDQ2IDI3IDE4IDI3QzE2Ljg5NTQgMjcgMTYgMjYuMTA0NiAxNiAyNUMxNiAyMy44OTU0IDE2Ljg5NTQgMjMgMTggMjNaIiBmaWxsPSIjQkZDMUM3Ii8+CiAgICA8cGF0aCBkPSJNMTggMTZDMTkuMTA0NiAxNiAyMCAxNi44OTU0IDIwIDE4QzIwIDE5LjEwNDYgMTkuMTA0NiAyMCAxOCAyMEMxNi44OTU0IDIwIDE2IDE5LjEwNDYgMTYgMThDMTYgMTYuODk1NCAxNi44OTU0IDE2IDE4IDE2WiIgZmlsbD0iI0JGQzFDNyIvPgogICAgPHBhdGggZD0iTTIwIDExQzIwIDkuODk1NDMgMTkuMTA0NiA5IDE4IDlDMTYuODk1NCA5IDE2IDkuODk1NDMgMTYgMTFDMTYgMTIuMTA0NiAxNi44OTU0IDEzIDE4IDEzQzE5LjEwNDYgMTMgMjAgMTIuMTA0NiAyMCAxMVoiIGZpbGw9IiNCRkMxQzciLz4KPC9zdmc+Cg==";
export { Svg3Dots as ReactComponent };